import { render, staticRenderFns } from "./carrier-note-input.vue?vue&type=template&id=4e5d6298&scoped=true"
import script from "./carrier-note-input.vue?vue&type=script&lang=js"
export * from "./carrier-note-input.vue?vue&type=script&lang=js"
import style0 from "./carrier-note-input.vue?vue&type=style&index=0&id=4e5d6298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d6298",
  null
  
)

export default component.exports